import { IMyAdvertisement } from 'types';

import {
  IModalAdvertisementManagerState,
  IModalAdvertisementViewState,
  IMyAdvertisementStatus,
} from '../../interfaces';

export enum EAdvertisementActiveStatus {
  ACTIVE = 'ACTIVE',
  NON_ACTIVE = 'NON_ACTIVE',
}

export interface IMyAdvertisementProps {
  data?: IMyAdvertisement[];
  loading: boolean;
  status: IMyAdvertisementStatus[];
  setStatus: React.Dispatch<React.SetStateAction<IMyAdvertisementStatus[]>>;
  setAdvertisementManagerState: React.Dispatch<
    React.SetStateAction<IModalAdvertisementManagerState | null>
  >;
  setAdvertisementViewState: React.Dispatch<
    React.SetStateAction<IModalAdvertisementViewState | null>
  >;
  advertisementStatus: EAdvertisementActiveStatus;
  setAdvertisementStatus: React.Dispatch<
    React.SetStateAction<EAdvertisementActiveStatus>
  >;
}
